<div class="container-fluid" style="padding:0px;margin:0px;">
  <!-- Header Section -->
  <div class="row mb-3">
    <div class="col-12">
      <div class="card border-primary">
        <div class="card-header bg-primary text-white">
          <h6 class="mb-0">
            <i class="fas fa-exchange-alt mr-2"></i>
            Thông tin chuyển lớp
          </h6>
        </div>
        <div class="card-body">

          <!-- Lý do -->
          <div class="row form-group">
            <label class="control-label col-md-2 col-form-label">
             
              Lý do <span class="text-danger">(*)</span>
            </label>
            <div class="col-md-10">
              <textarea type="text" 
                        tabIndex="1" 
                        #mafocus 
                        class="form-control" 
                        rows="4" 
                        placeholder="Nhập lý do chuyển lớp..." 
                        [(ngModel)]="doituongSelect.LyDo"></textarea>
              <small class="form-text text-muted">Vui lòng nhập lý do chuyển lớp</small>
            </div>
          </div>

          <!-- Ngày chuyển -->
          <div class="row form-group">
            <label class="control-label col-md-2 col-form-label">
             
              Ngày<span class="text-danger">(*)</span>
            </label>
            <div class="col-md-4">
              <kendo-dateinput tabIndex="2" 
                               [format]="'dd/MM/yyyy'" 
                               [(value)]="doituongSelect.Ngay"
                               style="width: 100%;"></kendo-dateinput>
            </div>
          </div>

          <!-- Lớp cũ và Lớp mới -->
          <div class="row form-group">
            <label class="control-label col-md-2 col-form-label">
           
              Lớp cũ <span class="text-danger">(*)</span>
            </label>
            <div class="col-md-4">
              <ng-select #slLopCu
                         class="twcollong"
                         [tabIndex]="5"
                         [openOnEnter]="false"
                         [items]="dslopcus"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         placeholder="Chọn lớp cũ..."
                         [searchFn]="comboSearchFn2"
                         [(ngModel)]="doituongSelect.LopCuId">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">
                      <i class="fas fa-chalkboard-teacher mr-2"></i>
                      {{item.Ten}}
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <label class="control-label col-md-2 col-form-label text-center">
             
              Lớp mới <span class="text-danger">(*)</span>
            </label>
            <div class="col-md-4">
              <ng-select #slLopMoi
                         class="twcollong"
                         [tabIndex]="7"
                         [openOnEnter]="false"
                         [items]="dslopmois"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         placeholder="Chọn lớp mới..."
                         [searchFn]="comboSearchFn2"
                         [(ngModel)]="doituongSelect.LopId">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell_1">
                      <i class="fas fa-chalkboard-teacher mr-2"></i>
                      {{item.Ten}}
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <!-- Visual Arrow Indicator -->
          <div class="row mb-3">
            <div class="col-md-2"></div>
            <div class="col-md-10">
              <div class="transfer-indicator">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="badge badge-danger mr-3">Lớp cũ</span>
                  <i class="fas fa-arrow-right fa-2x text-primary mx-3"></i>
                  <span class="badge badge-success ml-3">Lớp mới</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Ghi chú -->
          <div class="row form-group">
            <label class="control-label col-md-2 col-form-label">
             
              Ghi chú
            </label>
            <div class="col-md-10">
              <textarea type="text" 
                        tabIndex="9" 
                        rows="4" 
                        class="form-control" 
                        placeholder="Nhập ghi chú (nếu có)..." 
                        [(ngModel)]="doituongSelect.GhiChu"></textarea>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer border-top" style="display: flex; justify-content: space-between;">
  <div style="display:flex;">
    <small class="text-muted">
      <i class="fas fa-info-circle mr-1"></i>
      Các trường có dấu (*) là bắt buộc
    </small>
  </div>
  <div class="">
    <button class="btn btn-secondary" 
            (click)="closeModal()" 
            title="Ấn ESC để thoát">
      <i class="fas fa-times mr-1"></i>
      Hủy bỏ
    </button>
    <button type="submit" 
            (click)="saveproduct()" 
            title="Ấn F9 để lưu" 
            class="btn btn-primary ml-2">
      <i class="fas fa-save mr-1"></i>
      Lưu lại
    </button>
  </div>
</div>
